import { h } from "omi";

import { IconProps } from "@/components";

export function UploadCloudIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 21" width={width} height={height}>
      <path
        d="M6.6665 13.8333 9.99984 10.5m0 0 3.33336 3.3333M9.99984 10.5V18m6.66666-3.5476c1.0179-.8407 1.6667-2.1125 1.6667-3.5357 0-2.53134-2.0521-4.58337-4.5834-4.58337-.1821 0-.3524-.095-.4449-.25188C12.2182 4.23736 10.2119 3 7.9165 3c-3.45178 0-6.25 2.79822-6.25 6.25 0 1.7218.69621 3.2809 1.82246 4.4113"
        stroke="currentColor"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
